/**
 * @generated SignedSource<<d067f5ceb974629431e7460961b916d2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useJobApplication_JobApplication$data = {
  readonly profileCompatibleWithJob: boolean | null | undefined;
  readonly profileWillUpdateOnApply: boolean | null | undefined;
  readonly " $fragmentType": "useJobApplication_JobApplication";
};
export type useJobApplication_JobApplication$key = {
  readonly " $data"?: useJobApplication_JobApplication$data;
  readonly " $fragmentSpreads": FragmentRefs<"useJobApplication_JobApplication">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useJobApplication_JobApplication",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "profileWillUpdateOnApply",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "profileCompatibleWithJob",
      "storageKey": null
    }
  ],
  "type": "JobApplication",
  "abstractKey": null
};

(node as any).hash = "8d29e56aea73c842a57d83405c1ec79b";

export default node;
